
import { configureStore } from '@reduxjs/toolkit/react'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import media from '../reducers/media.reducers'
import { api } from './apiSlice'
import { api as mapboxApi } from './mapboxApiSlice'
import { api as userApi } from './userApiSlice'
import creatorReducer from './creatorSlice'
import authReducer from './authSlice'

/* const resetState = () => {
  console.debug('Migration running')
  return {} as PersistedState
}

const migrations = {
  8: resetState,
  9: resetState,
}

const storage = process.env.NODE_ENV === 'production' ? localforage : localstorage

const persistConfig = {
  key: 'echoes-creator',
  version: 9,
  storage,
  blacklist: ['stats'],
  migrate: createMigrate(migrations, { debug: false }),
}

const persistedReducer = persistReducer(persistConfig, rootReducer) */

const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    [mapboxApi.reducerPath]: mapboxApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    auth: authReducer,
    creator: creatorReducer,
    media,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(api.middleware, mapboxApi.middleware, userApi.middleware)
})

export type RootState = ReturnType<typeof store.getState>
export { store }
export type AppDispatch = typeof store.dispatch
export const useAppDispatch: () => AppDispatch = useDispatch
export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector
